import loadable from '@loadable/component';

export const CmsButtonLoadable = loadable(() => import('./CmsButton'), {
  resolveComponent: (module) => module.CmsButton,
});
